import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Subject } from 'rxjs/Subject';
import { loadingService } from 'app/core/service/loading.service';
import swal from 'sweetalert2';

function _window(): any {
  return window;
}

@Injectable()
export class PaybookService {

  subject = new Subject();
  errors = new Subject();

  get nativeWindow(): any {
    return _window();
  }

  user = {
    id: '',
    token: '',
  };

  timeout = 500;

  private api_key = 'b0f77c80be92defdea2dd378c63a58ac'; //'1e846961947aca549dd9993f59e7d215';

  private url = 'https://sync.paybook.com/v1/';

  constructor(private http: Http, private loadingService: loadingService) { }

  userExist(user: string, widget: string, bank: string) {
    return this.http.get(this.url + 'users?api_key=' + this.api_key)
      .map(data => data.json())
      .toPromise()
      .then(result => {
        const userLogin = result.response.filter(item => item.name === user)[0];
        
        if (userLogin) {
          this.user.id = userLogin.id_user;
          setTimeout(() => {
            this.initSession(userLogin.id_user, widget, bank);
          }, this.timeout);
        } else
        {
          setTimeout(() => {
            this.createUser(user, widget, bank);
          }, this.timeout);
        }
      })
      .catch(error => {
        this.errors.next(error);
      })
  }
  createUser(username: string, widget: string, bank: string) {
    this.http.post(this.url + 'users?api_key=' + this.api_key, { 'api_key': this.api_key, 'name': username })
      .map(data => data.json())
      .toPromise()
      .then(result => {
        setTimeout(() => {
          this.user.id = result.response.id_user;
          this.initSession(result.response.id_user, widget, bank);
        }, this.timeout);
      })
      .catch(error => {
        this.errors.next(error);
      })
  }

  initSession(userid: string, widget: string, bank: string) {
    this.http.post(this.url + 'sessions?api_key=' + this.api_key, { 'api_key': this.api_key, 'id_user': userid })
      .map(data => data.json())
      .toPromise()
      .then(result => {
        this.user.token = result.response.token;
        this.login(result.response.token, widget, bank);
      })
      .catch(error => {
        this.errors.next(error);
      })
  }

  login(token: string, widget: string, bank: string) {
    if (bank.length > 0) {
      if (bank == 'sat') {
        this.nativeWindow.syncWidget.setOptions({ token: token, baseDiv: widget, inc: ['58543125784806c3298b4572', '56cf5728784806f72b8b456f'] });
        //'56cf5728784806f72b8b456f'
      } else {
        this.nativeWindow.syncWidget.setOptions({ token: token, baseDiv: widget, inc: [bank] });
      }
    } else {
      this.nativeWindow.syncWidget.setOptions({ token: token, baseDiv: widget });
    }
  }

  getTransactions() {
    this.loadingService.showLoading();
    this.http.get(this.url + 'transactions?api_key=' + this.api_key + '&id_user=' + this.user.id + '&token=' + this.user.token)
      .map(data => data.json())
      .toPromise()
      .then(result => {
        swal({
          type: 'success',
          title: 'Importación completa',
          text: 'Se procesaron ' + result.response.length + " registros",
        }).then(r =>{
          this.deleteCurrentUser();
          this.loadingService.closeLoading();
        })
        
        this.subject.next(result.response);
      })
      .catch(error => {
        this.loadingService.closeLoading();
        this.errors.next(error);
      })
  }
  deleteCurrentUser() {
    this.http.delete(this.url + 'users/' + this.user.id +'?api_key=' + this.api_key)
      .map(data => data.json())
      .toPromise()
      .then(result => {
        //var x = result;
        swal({
          type: 'warning',
          title: 'Atención',
          text: 'La conexión quedara cerrada por seguridad',
        });
      })
      .catch(error => {
        this.errors.next(error);
      })
  }

  closeConection()
  {
    this.deleteCurrentUser();
  }

  getUsers()
  {
    this.http.get(this.url + 'users/?api_key=' + this.api_key)
    .map(data => data.json())
    .toPromise()
    .then(result => {
      //var x = result;
      //console.log('user deleted', result);
    })
    .catch(error => {
      this.errors.next(error);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/paybook/paybook.service.ts